@if (!hasClicked) {
  <span
    [ngbTooltip]="expandOnClick ? 'Click the &quot;...&quot; to expand the field.' : undefined"
    class="pointer"
    (click)="onClick()"
    >
    {{ lessData }}...
  </span>
}
@if (hasClicked) {
  <span>
    {{ data }}
  </span>
}
